import Swal from "sweetalert2";
import { call, put, takeLeading } from "redux-saga/effects";
import { Color } from "../../assets/colors";
import * as actionTypes from "../actionTypes";
import { getAPI, postAPI } from "../../utils/api-function";
import { create_language, delete_language, get_language, update_language } from "../../utils/api-routes";

function* getLanguage() {
  try {
    yield put({ type: actionTypes.SET_IS_LOADING, payload: true });
    const { data } = yield getAPI(get_language);
    console.log("Get Language Saga Response ::: ", data);

    if (data?.success) {
      yield put({ type: actionTypes.SET_LANGUAGE, payload: data?.languageData?.reverse() });
      yield put({ type: actionTypes.SET_IS_LOADING, payload: false });
    }

  } catch (error) {
    yield put({ type: actionTypes.SET_IS_LOADING, payload: false });
    console.log("Get Language Saga Error ::: ", error);
  }
};

function* createLanguage(action) {
  try {
    const { payload } = action;
    console.log("Payload ::: ", payload);

    const { data } = yield postAPI(create_language, payload?.data);
    console.log("Create Language Saga Response ::: ", data);

    if (data?.success) {
      Swal.fire({ icon: "success", title: 'Success', text: "Language Created Successfully", showConfirmButton: false, timer: 2000 });
      yield call(payload?.onComplete);
    }

  } catch (error) {
    Swal.fire({ icon: "error", title: 'Failed', text: error?.response?.data?.message + ' ' + error?.response?.data?.error, showConfirmButton: false, timer: 2000 });
    console.log("Create Language Saga Error ::: ", error);
  }
};

function* updateLanguage(action) {
  try {
    const { payload } = action;
    console.log("Payload ::: ", payload);

    const { data } = yield postAPI(update_language, payload?.data);
    console.log("Update Language Saga Response ::: ", data);

    if (data?.success) {
      Swal.fire({ icon: "success", title: 'Success', text: "Language Updated Successfully", showConfirmButton: false, timer: 2000 });
      yield call(payload?.onComplete);
    }

  } catch (error) {
    Swal.fire({ icon: "error", title: 'Failed', text: error?.response?.data?.message, showConfirmButton: false, timer: 2000 });
    console.log("Update Language Saga Error ::: ", error);
  }
};

function* deleteLanguage(action) {
  try {
    const { payload } = action;

    const result = yield Swal.fire({ icon: "warning", title: `Are you sure ?`, text: "You want to delete!!!", showCancelButton: true, confirmButtonColor: Color.primary, cancelButtonColor: 'grey', confirmButtonText: "Yes", cancelButtonText: "No" });

    if (result.isConfirmed) {
      const { data } = yield postAPI(delete_language, payload);
      console.log("Delete Language Saga Response ::: ", data);

      if (data?.success) {
        Swal.fire({ icon: "success", title: 'Success', text: "Language Deleted Successfully", showConfirmButton: false, timer: 2000 });
        yield put({ type: actionTypes?.GET_LANGUAGE, payload: null });
      }
    }

  } catch (error) {
    Swal.fire({ icon: "error", title: 'Failed', text: "Failed To Delete", showConfirmButton: false, timer: 2000 });
    console.log("Delete Language Saga Error ::: ", error);
  }
};

export default function* languageSaga() {
  yield takeLeading(actionTypes.GET_LANGUAGE, getLanguage);
  yield takeLeading(actionTypes.CREATE_LANGUAGE, createLanguage);
  yield takeLeading(actionTypes.UPDATE_LANGUAGE, updateLanguage);
  yield takeLeading(actionTypes.DELETE_LANGUAGE, deleteLanguage);
};